import { Theme, createStyles, makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      alignItems: "center",
    },
    typography: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-end",
      justifyContent: "center",
    },
    button: {
      margin: "0 0 0 12px",
      padding: 0,
      "& svg": {
        width: 20.83,
        height: 18,
      },
      "&:hover": {
        backgroundColor: "inherit",
      },
    },
    avatar: {
      marginLeft: "16px"
    },
    avatarIE:{
      position: "relative",
      width: "40px",
      height: "40px",
      overflow: "hidden",
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      marginLeft: "16px",
      borderRadius: "50%",
      backgroundColor: "#FFF"
    },
    avatarIEImage: {
      height: "100%",
    },
    status: {
      fontWeight: "normal",
      lineHeight: "16px",
      fontSize: "12px",
      color: theme.palette.common.white,
      opacity: 0.6,
    },
    accountname: {
      textAlign: "right",
      fontWeight: "normal",
      lineHeight: "16px",
      fontSize: "12px",
      color: theme.palette.common.white,
      "&:hover": {
        textDecoration: "underline",
      },
    },
    link: {
      border: "none",
      "&:hover": {
        border: "none",
      },
    },
    divider: {
      marginRight: 29,
      backgroundColor: "#FFFFFF",
      opacity: 0.25,
      borderRadius: 1,
      width: 2,
      height: 24,
    },
    searchIcon: {
      padding: 0,
      margin: "0 11px 0 0",
      "& svg": {
        width: 24,
        height: 24,
        opacity: 0.9,
        fill: "none",
      },
      "&:hover": {
        backgroundColor: "inherit",
      },
    },
  }),
);
